import { render, staticRenderFns } from "./RemarkDialog.vue?vue&type=template&id=67f937c9&scoped=true"
import script from "./RemarkDialog.vue?vue&type=script&lang=js"
export * from "./RemarkDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67f937c9",
  null
  
)

export default component.exports